import { HStack, IconButton, Separator, useToggle } from '@revolut-internal/ui-kit'
import { FC } from 'react'

import { AssistantPlaygroundCapabilitiesModal } from '../AssistantPlaygroundCapabilitiesModal'

export const AssistantPlaygroundGlobalActions: FC = () => {
  const [assistantCapabilitiesOpen, toggleAssistantCapabilitiesOpen] = useToggle()

  return (
    <HStack height="s-24" align="center">
      <IconButton useIcon="InfoOutline" onClick={toggleAssistantCapabilitiesOpen.on}>
        Assistant capabilities
      </IconButton>
      <Separator orientation="vertical" ml="s-16" />

      <AssistantPlaygroundCapabilitiesModal
        open={assistantCapabilitiesOpen}
        onClose={toggleAssistantCapabilitiesOpen.off}
      />
    </HStack>
  )
}
